import React from 'react'

import { useEnvironment } from '../../../providers/EnvironmentProvider'
import { useBreakpoint } from '@SonarCX/providers/BreakpointProvider'
import useStyles from './styles'

type EnvironmentNameProps = {
  padLeft?: number
}

const EnvironmentName: React.FC<EnvironmentNameProps> = ({ padLeft }) => {
  const { env, loaded } = useEnvironment()
  const { isExtraSmall } = useBreakpoint()

  const classes = useStyles({ padLeft })

  if (isExtraSmall) {
    return null
  }

  return (
    <div className={classes.root}>
      <label className={classes.name}>{loaded ? env?.name ?? '' : ''}</label>
    </div>
  )
}

export default EnvironmentName
